import { CellContext } from '@tanstack/react-table';
import { EmptyValue } from '@/components/ui/EmptyValue.tsx';

interface NestedAppUserValue {
  id: string;
  firstName: string | null;
  lastName: string;
  email: string;
  role: string;
}

/** Zwykły tekst, bo użytkownik aplikacji nie ma własnego ekranu. */
export const nestedAppUserFieldRender = <T,>(info: CellContext<T, unknown>) => {
  const value = info.getValue() as NestedAppUserValue | null | undefined;
  // jOOQ oddaje brak wiersza jako obiekt z samymi `null`-ami, nie jako `null`.
  if (!value?.id) return <EmptyValue />;
  // company_user.first_name jest nullable w bazie, więc łączymy tylko obecne człony.
  return [value.firstName, value.lastName].filter(Boolean).join(' ');
};
